import { render, staticRenderFns } from "./MassShareDocuments.vue?vue&type=template&id=309bb9e8&scoped=true&"
import script from "./MassShareDocuments.vue?vue&type=script&lang=js&"
export * from "./MassShareDocuments.vue?vue&type=script&lang=js&"
import style0 from "./MassShareDocuments.vue?vue&type=style&index=0&id=309bb9e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309bb9e8",
  null
  
)

export default component.exports